module.exports = __webpack_public_path__ + "static/card-8-40c44074eafbb2c8e40ae5eb9a7559e3.png";